import { UIElements } from '@ansvar-sakerhet/ui';
import styled from 'styled-components';

const Title = styled(UIElements.B2)`
  font-weight: 400;
  margin-bottom: 4px;
`;

export const S = { ...UIElements, Title };
